import { Lockup } from '@/components/brand/Brand'
import { sitePages } from '@/config/pages'
import { communityCopy, formatNominationNumber } from '@/nominations/communityCopy'

type NominationTopBarProps = {
  number: number
}

/** The site's sticky nav pills, holding the brand and the nomination number instead of links. */
export const NominationTopBar = ({ number }: NominationTopBarProps) => (
  <header className="nav">
    <a className="nav-brand glass" href={sitePages.home.path} aria-label="United Accountants">
      <Lockup />
    </a>
    <p className="nom-topbar glass">
      <span className="nom-label">{communityCopy.topBarEyebrow}</span>
      <span className="nom-number">{formatNominationNumber(number)}</span>
    </p>
  </header>
)
